import React from 'react'
import { Box, FormLabel, FormControl, FormErrorMessage, Text, HStack, RadioGroup, Radio} from '@chakra-ui/react'

const ToggleGroup = ({error, label, description, value, onChange, required, options = [],  ...rest}) => {

    let info = false    
    let selected_value = options?.find((x) => x?.value === value);
    info = selected_value?.description || false

    return(
        <Box>
            <FormControl isInvalid={error}>
                {label && <FormLabel fontSize="12px" mb="3" color="gray.400" fontWeight="600" textTransform="uppercase">{label} {required && <Text as={'span'} fontSize="xs" color="red">*</Text>}</FormLabel>}
                <FormErrorMessage>{error}</FormErrorMessage>
                <RadioGroup value={value} onChange={onChange} >
                    <HStack flexWrap="wrap" spacing="4">
                    {
                        options.map((opt, o) =>
                            <Radio  _focus={{ shadow: "none" }}  colorScheme={opt?.color || 'brand'} key={o} value={opt.value}>
                                <Text fontWeight="600" fontSize="sm" textTransform="capitalize">{opt.label}</Text>
                            </Radio>
                        )
                    }
                    </HStack>
                </RadioGroup>                
                {info &&  <Text my="4" fontSize="sm" color="gray.500">
                    <Text as="span" fontStyle="italic" fontWeight="600" color="red.500">Note: </Text>
                    {info}
                </Text> }
            </FormControl>
        </Box>
    )
}

export { ToggleGroup }